import {
  CLEAR_PICKLIST_STATE,
  SET_CURRENT_PICKLIST,
  SET_LOAD_MORE_FLAG,
  SET_PICKLIST_FILTER,
  SET_PICKLIST_CREATION_FORM
} from '../constants/reduceConstants';
import api from '../api';
import { SUCCESS_CREATE_PICKLIST, SUCCESS_UPDATE_PICKLIST } from '../constants/infoSnackbarData';
import { browserHistory } from '../browserHistory';
import { PICKLIST_DETAILED_PATH } from '../constants/routeConstants';
import { enqueueErrorSnackbar, enqueueSuccessSnackbar } from 'helpers/AppHelpers';

// Summary Screen
export const getPicklists = (query) => (dispatch) =>
  api.picklist
    .getPicklistsApi(query)
    .then((res) => {
      dispatch({ type: SET_LOAD_MORE_FLAG, payload: false });
      return res;
    })
    .catch((err) => console.log(err));

export const getFilterCriteria = () => () =>
  api.picklist
    .getFilterCriteriaApi()
    .then((res) => res)
    .catch((err) => console.log(err));

export const getSummaryCsvResource = (q) => () =>
  api.picklist
    .getSummaryCsvResourceApi(q)
    .then((res) => res)
    .catch((err) => console.log(err));

export const setFilter = (payload) => (dispatch) =>
  dispatch({ type: SET_PICKLIST_FILTER, payload });

// Edit Screen
export const getLocations = (query) => () =>
  api.picklist
    .getLocationsApi(query)
    .then((res) => res)
    .catch((err) => console.log(err));

export const getProjects = (query) => () =>
  api.picklist
    .getProjectsApi(query)
    .then((res) => res)
    .catch((err) => console.log(err));

export const createPicklist = (data) => () =>
  api.picklist.createPicklistApi(data).then(
    (res) => {
      enqueueSuccessSnackbar(SUCCESS_CREATE_PICKLIST);
      browserHistory.push(`${PICKLIST_DETAILED_PATH}/${res.id}`);
    },
    (err) => {
      const errors = JSON.parse(err.request.response);
      return errors;
    }
  );

export const setCreationForm = (payload) => (dispatch) =>
  dispatch({ type: SET_PICKLIST_CREATION_FORM, payload });

// Common
export const updatePicklist =
  (data, { shouldRedirectToDetails = true, shouldDisplayActionPopup = true } = {}) =>
  (dispatch) => {
    return api.picklist.updatePicklistApi(data).then(
      (res) => {
        shouldDisplayActionPopup && enqueueSuccessSnackbar(SUCCESS_UPDATE_PICKLIST);
        !shouldRedirectToDetails && browserHistory.push(`${PICKLIST_DETAILED_PATH}/${res.id}`);
        dispatch({ type: SET_CURRENT_PICKLIST, payload: res });
        return res;
      },
      (err) => {
        const errors = JSON.parse(err.request.response);
        enqueueErrorSnackbar('', errors);
        return errors;
      }
    );
  };

export const clearState = () => (dispatch) => dispatch({ type: CLEAR_PICKLIST_STATE });
